import { max as mathMax, min as mathMin } from "./math.js";
export default function within(min, value, max) {
  return mathMax(min, mathMin(value, max));
}


//////////////////
// WEBPACK FOOTER
// /Users/andrea/Siti/idroexpert.com/new/new.idroexpert.test/wp-content/themes/sage/node_modules/@popperjs/core/lib/utils/within.js
// module id = 28
// module chunks = 0